import { useIntl } from 'react-intl';

import { getLocalUserId } from 'src/features/auth';
import { ParkingCard } from 'src/features/parkingManagement/components/ParkingCard';
import { parkingManagementMessages } from 'src/features/parkingManagement/utils/messages';
import { useListUserMemberships } from 'src/features/profile/api/useListUserMemberships';
import {
    SectionBlock,
    SectionBlockBody,
    SectionBlockHead,
    SectionBlockHeader,
    SectionBlockSeparator,
    SectionBlockSubtitle,
    SectionBlockTitle,
} from 'src/registry/components/blocks/SectionBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';

const ParkingManagement = () => {
    const { formatMessage } = useIntl();
    const userId = getLocalUserId();

    const { data, isLoading } = useListUserMemberships({ userId });

    return (
        <SectionBlock>
            <SectionBlockHeader>
                <SectionBlockHead>
                    <SectionBlockTitle>{formatMessage(parkingManagementMessages.allParkings)}</SectionBlockTitle>
                    <SectionBlockSubtitle>
                        {formatMessage(parkingManagementMessages.parkingManagementSectionSubtitle)}
                    </SectionBlockSubtitle>
                </SectionBlockHead>
            </SectionBlockHeader>
            <SectionBlockSeparator />
            <SectionBlockBody className="grid lg:grid-cols-2">
                {!isLoading
                    ? data?.map(({ parking, role }) => {
                          return <ParkingCard key={parking.id} parking={parking} role={role} />;
                      })
                    : Array.from(Array(3).keys()).map((_, i) => {
                          return (
                              <Skeleton
                                  key={i}
                                  className="aspect-video w-full sm:aspect-auto sm:h-40 lg:h-48 xl:h-40"
                              />
                          );
                      })}
            </SectionBlockBody>
        </SectionBlock>
    );
};

export default ParkingManagement;
